import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as yup from "yup";
import Fade from "react-reveal/Fade";
import { yupResolver } from "@hookform/resolvers/yup";
import { useFieldArray, useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";
import { getSetupDetails, saveSetupWizardForm } from "../../../Redux/actions";
import SWInterface from "../../Components/Layout/SWInterface";
import { removeUnderScore } from "../../../helpers";
import ErrorContainer from "../../Components/ErrorContainer";
import BtmButtons from "../../Components/BtmButtons";

const urlMsg = "Link must be a valid URL";
const reqMsg = "This field is required";
const regMatch =
  /((https?):\/\/)?(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/;
const schema = yup
  .object({
    merchant_data: yup.array().of(
      yup.object().shape({
        id: yup.string(),
        link: yup.string().url(urlMsg),
        onlife_site_id: yup.string().required(),
        merchant_id: yup.string().required(),
        link_name: yup.string(),
        name: yup.string(),
      })
    ),
    onlife_site_link: yup.array().of(
      yup.object().shape({
        id: yup.string(),
        link: yup.string().url(urlMsg),
        onlife_site_id: yup.string().required(),
        merchant_id: yup.string().required(),
        link_name: yup.string(),
        name: yup.string(),
      })
    ),
    competitor_name: yup.string().when("onlife_site_link", {
      is: (links) => links.findIndex((p) => p.link !== "") > -1,
      then: yup.string().required(),
    }),
  })
  .required();

const SetupWizardNine = (params) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const {
    account,
    merchantData,
    onlifeSites,
    icon_classes,
    onlifeSitesCompetitors,
    competitors,
  } = useSelector((state) => state.authReducer.setup_wizard_details);

  const initialForm = {
    id: "",
    merchant_data: [],
    onlife_site_link: [],
    competitor_name: "",
    competitor_id: "",
  };
  const {
    register,
    formState: { errors },
    handleSubmit,
    control,
    setValue,
    reset,
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: initialForm,
    mode: "all",
    reValidateMode: "onChange",
  });

  const {
    fields: merchantFields,
    append: merchantAppend,
    remove: merchantRemove,
  } = useFieldArray({
    control,
    name: "merchant_data",
  });

  const {
    fields: onlifeFields,
    append: onlifeAppend,
    remove: onlifeRemove,
  } = useFieldArray({
    control,
    name: "onlife_site_link",
  });

  const [inputForm, setInputForm] = useState(initialForm);
  const isLogoutRef = useRef(false);
  const submitBtnRef = useRef(null);

  const changeInputHandler = (index, para, input, val) => {
    setValue(`${para}.${index}.${input}`, val);
    inputForm[para][index] = {
      ...inputForm[para][index],
      [input]: val,
    };
    setInputForm({ ...inputForm });
  };

  const changeSingleInputHandler = (input, val) => {
    setValue(`${input}`, val);
    setInputForm({ ...inputForm, [input]: val });
  };

  const getErrorContainer = (index, type, para) => {
    return (
      <div className={"errorDiv"}>
        <Fade
          right
          collapse
          when={
            errors && errors?.[para]?.[index]?.[type]?.message ? true : false
          }
        >
          <label className="error">
            {errors?.[para]?.[index]?.[type]?.message
              ? removeUnderScore(errors?.[para]?.[index]?.[type]?.message)
              : ""}
          </label>
        </Fade>
      </div>
    );
  };

  useEffect(() => {
    let merchantDataArr = [];
    let onlifeDataArr = [];
    if (merchantData && merchantData.length > 0) {
      merchantData.map((merchantObj, merInd) => {
        const merchantDataObj = {
          id: merchantObj?.id ?? "",
          icon: icon_classes?.[merchantObj?.name] ?? "",
          link: merchantObj?.link ?? "",
          onlife_site_id: merchantObj?.onlife_site_id ?? "",
          merchant_id: merchantObj?.merchant_id ?? "",
          link_name: merchantObj?.link_name ?? "",
          name: merchantObj?.name ?? "",
        };
        merchantAppend(merchantDataObj);
        merchantDataArr.push(merchantDataObj);
      });
    }
    if (onlifeSitesCompetitors && onlifeSitesCompetitors.length > 0) {
      onlifeSitesCompetitors.map((onlifeComp, comInd) => {
        const onlifeCompObj = {
          id: onlifeComp?.id ?? "",
          icon: icon_classes?.[onlifeComp?.name] ?? "",
          link: onlifeComp?.link ?? "",
          onlife_site_id: onlifeComp?.onlife_site_id ?? "",
          merchant_id: onlifeComp?.merchant_id ?? "",
          link_name: onlifeComp?.link_name ?? "",
          name: onlifeComp?.name ?? "",
        };
        onlifeAppend(onlifeCompObj);
        onlifeDataArr.push(onlifeCompObj);
      });
    }
    if (onlifeSites && onlifeSites.length > 0) {
      console.log("onlifeSites", onlifeSites);
      onlifeSites.map((onlifeSiteObj, onlifeInd) => {
        const onlifeSiteDataObj = {
          id: "",
          icon: icon_classes?.[onlifeSiteObj?.name] ?? "",
          link: onlifeSiteObj?.link ?? "",
          onlife_site_id: onlifeSiteObj?.id ?? "",
          merchant_id: account?.merchant_id ?? "",
          link_name: onlifeSiteObj?.link_name ?? "",
          name: onlifeSiteObj?.name ?? "",
        };
        if (!(merchantData && merchantData.length > 0)) {
          merchantAppend(onlifeSiteDataObj);
          merchantDataArr.push(onlifeSiteDataObj);
        }
        if (!(onlifeSitesCompetitors && onlifeSitesCompetitors.length > 0)) {
          onlifeAppend(onlifeSiteDataObj);
          onlifeDataArr.push(onlifeSiteDataObj);
        }
      });
    }
    console.log("merchantDataArr", merchantDataArr);
    console.log("onlifeDataArr", onlifeDataArr);
    setInputForm({
      merchant_data: merchantDataArr,
      onlife_site_link: onlifeDataArr,
      competitor_name: competitors?.name ?? "",
      competitor_id: competitors?.id ?? "",
    });
    reset({
      merchant_data: merchantDataArr,
      onlife_site_link: onlifeDataArr,
      competitor_name: competitors?.name ?? "",
      competitor_id: competitors?.id ?? "",
    });
  }, [
    merchantData,
    onlifeSites,
    icon_classes,
    onlifeSitesCompetitors,
    competitors,
  ]);

  useEffect(() => {
    dispatch(getSetupDetails(8));
  }, []);

  const submitForm = (data) => {
    if (
      data?.onlife_site_link &&
      !(data.onlife_site_link.findIndex((p) => p.link !== "") > -1)
    ) {
      delete data.onlife_site_link;
      delete data.competitor_id;
    }
    console.log("submitForm", data);
    dispatch(saveSetupWizardForm("eight", data, isLogoutRef?.current));
  };

  const submitNextHandler = (isLogoutType = false) => {
    isLogoutRef.current = isLogoutType;
    if (submitBtnRef !== null) {
      submitBtnRef.current.click();
    }
  };

  return (
    <SWInterface step={8}>
      {console.log("errors", errors)}
      <div className="steps-content">
        <div className="steps-div_outer">
          <div className="steps-div d-block">
            <h4 className="event-alert mb-0"> Onlife Setup</h4>
            <p className="mt-0">
              By following the below instructions, you will be able to see all
              of your company's reviews across 3 major consumer rating sites and
              how it compares to your competitors all in one place in the Onlife
              Module.
            </p>
            <form id="form_step_eight" onSubmit={handleSubmit(submitForm)}>
              <div className="row-fluid onlife-page mt-4">
                <div className="row-fluid">
                  <div className="span12 setup-inst">
                    <ul className="px-0">
                      <li>
                        <em>1</em>Select one of the below site hyperlinks and
                        navigate to your business'/competitor's page on the
                        given site
                      </li>
                      <li>
                        <em>2</em>Return to this screen and paste the full URL
                        into the applicable field below.
                      </li>

                      <li className="d-inline-block">
                        <em>3</em> Please allow xxx mins after saving changes to
                        give the system some time to retrieve and process the
                        Onlife data, the{" "}
                        <span className="green-txt">GREEN </span>
                        check mark will appear when the system has successfully
                        retrieved and processed the data. The
                        <span className="pink-txt"> RED</span> “x” indicates an
                        issue with the URL provided, please try again or contact
                        support if you contnue to have issues.
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="row-fluid other_input">
                  <div className="col-12">
                    <div className="well light_blue">
                      <div className="well-header">
                        <h5>{account?.merchant?.account_name ?? "-"}</h5>
                      </div>
                      <div className="well-content no-search">
                        {merchantFields &&
                          merchantFields.length > 0 &&
                          merchantFields.map((merchantField, index) => {
                            return (
                              <div className="form_row">
                                <label className="field_name">
                                  <em
                                    className={`circle-icon ${
                                      merchantField?.icon ?? ""
                                    }`}
                                  ></em>
                                  {merchantField?.name ?? "N/A"}
                                  <i class="cross-icon"></i>
                                </label>
                                <div className="field">
                                  <div class="input text col-12">
                                    <label>Link</label>
                                    <input
                                      {...register(
                                        `merchant_data.${index}.link`
                                      )}
                                      onChange={(event) =>
                                        changeInputHandler(
                                          index,
                                          "merchant_data",
                                          "link",
                                          event?.target?.value
                                        )
                                      }
                                      value={
                                        inputForm?.merchant_data?.[index]?.link
                                      }
                                      class="col-12"
                                      placeholder="Add URL Here"
                                      type="text"
                                    />
                                    {getErrorContainer(
                                      index,
                                      "link",
                                      "merchant_data"
                                    )}
                                    <input
                                      {...register(
                                        `merchant_data.${index}.onlife_site_id`
                                      )}
                                      value={
                                        inputForm?.merchant_data?.[index]
                                          ?.onlife_site_id
                                      }
                                      type="hidden"
                                    />
                                    {getErrorContainer(
                                      index,
                                      "onlife_site_id",
                                      "merchant_data"
                                    )}
                                    <input
                                      {...register(
                                        `merchant_data.${index}.merchant_id`
                                      )}
                                      value={
                                        inputForm?.merchant_data?.[index]
                                          ?.merchant_id
                                      }
                                      type="hidden"
                                    />
                                    {getErrorContainer(
                                      index,
                                      "merchant_id",
                                      "merchant_data"
                                    )}
                                    <input
                                      {...register(
                                        `merchant_data.${index}.link_name`
                                      )}
                                      value={
                                        inputForm?.merchant_data?.[index]
                                          ?.link_name
                                      }
                                      type="hidden"
                                    />
                                    {getErrorContainer(
                                      index,
                                      "link_name",
                                      "merchant_data"
                                    )}
                                    <input
                                      {...register(
                                        `merchant_data.${index}.name`
                                      )}
                                      value={
                                        inputForm?.merchant_data?.[index]?.name
                                      }
                                      type="hidden"
                                    />
                                    {getErrorContainer(
                                      index,
                                      "name",
                                      "merchant_data"
                                    )}
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                      </div>
                    </div>

                    <div className="well light_blue">
                      <div className="well-header">
                        <div className="input text mt-3">
                          <label>Name</label>
                          <input
                            {...register(`competitor_id`)}
                            value={inputForm?.competitor_id}
                            type="hidden"
                          />
                          <input
                            {...register(`competitor_name`)}
                            onChange={(event) =>
                              changeSingleInputHandler(
                                "competitor_name",
                                event?.target?.value
                              )
                            }
                            value={inputForm?.competitor_name}
                            className="col-4"
                            placeholder="Add Name For Competitor"
                            type="text"
                          />
                          <ErrorContainer
                            errors={errors}
                            name="competitor_name"
                          />
                          <ErrorContainer
                            errors={errors}
                            name="competitor_id"
                          />
                        </div>
                        <div className="clear"></div>
                      </div>

                      <div className="col-12">
                        <div className="well light_blue">
                          <div className="well-content no-search">
                            {onlifeFields &&
                              onlifeFields.length > 0 &&
                              onlifeFields.map((onlifeField, index) => {
                                return (
                                  <div className="form_row">
                                    <label className="field_name">
                                      <em
                                        className={`circle-icon ${
                                          onlifeField?.icon ?? ""
                                        }`}
                                      ></em>
                                      {onlifeField?.name ?? "N/A"}
                                      <i class="cross-icon"></i>
                                    </label>
                                    <div className="field">
                                      <div class="input text col-12">
                                        <label>Link</label>
                                        <input
                                          {...register(
                                            `onlife_site_link.${index}.link`
                                          )}
                                          onChange={(event) =>
                                            changeInputHandler(
                                              index,
                                              "onlife_site_link",
                                              "link",
                                              event?.target?.value
                                            )
                                          }
                                          value={
                                            inputForm?.onlife_site_link?.[index]
                                              ?.link
                                          }
                                          class="col-12"
                                          placeholder="Add URL Here"
                                          type="text"
                                        />
                                        {getErrorContainer(
                                          index,
                                          "link",
                                          "onlife_site_link"
                                        )}
                                        <input
                                          {...register(
                                            `onlife_site_link.${index}.onlife_site_id`
                                          )}
                                          value={
                                            inputForm?.onlife_site_link?.[index]
                                              ?.onlife_site_id
                                          }
                                          type="hidden"
                                        />
                                        {getErrorContainer(
                                          index,
                                          "onlife_site_id",
                                          "onlife_site_link"
                                        )}
                                        <input
                                          {...register(
                                            `onlife_site_link.${index}.merchant_id`
                                          )}
                                          value={
                                            inputForm?.onlife_site_link?.[index]
                                              ?.merchant_id
                                          }
                                          type="hidden"
                                        />
                                        {getErrorContainer(
                                          index,
                                          "merchant_id",
                                          "onlife_site_link"
                                        )}
                                        <input
                                          {...register(
                                            `onlife_site_link.${index}.link_name`
                                          )}
                                          value={
                                            inputForm?.onlife_site_link?.[index]
                                              ?.link_name
                                          }
                                          type="hidden"
                                        />
                                        {getErrorContainer(
                                          index,
                                          "link_name",
                                          "onlife_site_link"
                                        )}
                                        <input
                                          {...register(
                                            `onlife_site_link.${index}.name`
                                          )}
                                          value={
                                            inputForm?.onlife_site_link?.[index]
                                              ?.name
                                          }
                                          type="hidden"
                                        />
                                        {getErrorContainer(
                                          index,
                                          "name",
                                          "onlife_site_link"
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                );
                              })}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <button
                  type="submit"
                  style={{ display: "none" }}
                  ref={submitBtnRef}
                >
                  Submit
                </button>
                <BtmButtons submitHandler={submitNextHandler} />
              </div>
            </form>
          </div>
        </div>
      </div>
    </SWInterface>
  );
};
export default SetupWizardNine;
